export { SkeletonFragment } from '@music-vine/cadence/ui';
interface SkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  items?: number;
}

/**
 * @deprecated Use ui/skeleton instead
 */
export const Skeleton = ({
  items = 1,
  ...props
}: SkeletonProps) => Array.from({
  length: items
}).map((_, i) => <span key={i} {...props} />);